import Icon from 'veui/components/Icon'

Icon.register({
  'file-sync': {
    paths: [
      {
        d: 'M416 704a32 32 0 01-32 32H128a32 32 0 01-32-32V64a32 32 0 0132-32h512a32 32 0 0132 32v256a32 32 0 01-64 0V96H160v576h224a32 32 0 0132 32zM256 192a32 32 0 000 64h256a32 32 0 000-64zm128 160H256a32 32 0 000 64h128a32 32 0 000-64zm156.62 177.69a32 32 0 00-37.13-16.55A96 96 0 01624 492.83a32 32 0 1032-55.39A160 160 0 00576 416c-88.22 0-160 71.78-160 160a32 32 0 0046.31 28.62l64-32a32 32 0 0014.31-42.93zm180 19a32 32 0 00-31.32-1.11l-64 33a32 32 0 0022 59.59 96 96 0 01-119.34 19A32 32 0 10496 714.56 160 160 0 00576 736c88.22 0 160-71.78 160-160a32 32 0 00-15.35-27.33z'
      }
    ],
    width: '768',
    height: '768'
  }
})
